import React from 'react';
import LoadingBackdrop from '../components/LoadingBackdrop';

export default function LoadingPage() {
  return <LoadingBackdrop open={true} />;
}
